export default __webpack_public_path__ + "static/media/logo.77d2f3f5.png";